import { CollectionIcon, VideoCameraIcon } from '@heroicons/react/solid';
import { faSoundcloud } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'wouter';
import SocialMedia from './SocialMedia';

function SidebarLayout() {
  return (
    <div
      className="text-red-500 p-5 text-xs lg:text-sm border-r 
            border-black overflow-y-scroll scrollbar-hide hidden 
              h-screen sm:min-w-[13.5rem] lg:min-w-[14rem] md:inline-flex pb-32
              shadowMarginSidebar"
    >
      <div className="space-y-4 -mx-5 md:-mt-5 lg:-mt-7 xl:-mt-9">
        <Link
          className="flex items-center space-x-2 hover:text-white hover:sidebarBtn cursor-pointer"
          to="/genres"
        >
          <CollectionIcon className="h-5 w-8" />
          <p>Genres</p>
        </Link>

        <Link
          className="flex items-center space-x-2 hover:text-white hover:sidebarBtn cursor-pointer"
          to="/soundcloud"
        >
          <FontAwesomeIcon className="h-5 w-8" icon={faSoundcloud} />
          <p>SoundCloud</p>
        </Link>

        {/*<Link
                  className="flex items-center space-x-2 hover:text-white hover:dance cursor-pointer"
                  to="/residents"
                >
                  <UserGroupIcon className="h-5 w-8" />
                  <p>Residentes</p>
                </Link>
                <Link
                  className="flex items-center space-x-2 hover:text-white hover:dance cursor-pointer"
                  to="/charts"
                >
                  <FireIcon className="h-5 w-8" />
                  <p>Charts</p>
                </Link>
                <hr className="border-t-[0.1px] border-red-900" />
                <Link
                  className="flex items-center space-x-2 hover:text-white hover:dance cursor-pointer"
                  to="/my-music"
                >
                  <MusicNoteIcon className="h-5 w-8" />
                  <p>Music</p>
                </Link>
                <Link
                  className="flex items-center space-x-2 hover:text-white hover:dance cursor-pointer"
                  to="/create-playlist"
                >
                  <PlusCircleIcon className="h-5 w-8" />
                  <p>Create Playlist</p>
                </Link>
                <Link
                  className="flex items-center space-x-2 hover:text-white hover:dance cursor-pointer"
                  to="/liked-Songs"
                >
                  <HeartIcon className="h-5 w-8" />
                  <p>Liked Songs</p>
                </Link>*/}
        <Link
          className="flex items-center space-x-2 hover:text-white hover:sidebarBtn cursor-pointer"
          to="/dj-sets"
        >
          <VideoCameraIcon className="h-5 w-8" />
          <p>DJ Sets</p>
        </Link>

        <hr className="border-t-[0.1px] border-red-900" />
        {/* SocialMedia */}
        <SocialMedia />

        {/* Donate 
                <hr className="border-t-[0.1px] border-red-900" />
                <Donate />
                */}
      </div>
    </div>
  );
}

export default SidebarLayout;
